const positiveConsentTemplates = [
  'POSITIVE_CONSENT_ISA',
  'POSITIVE_CONSENT_ISA_APPLICATION',
  'POSITIVE_CONSENT_SIPP',
  'POSITIVE_CONSENT_SIPP_ISA',
];

// The tick-only consent blocks: a document to read and no signature.
export default function isPositiveConsentTemplate(template: string) {
  return positiveConsentTemplates.includes(template);
}
